<!-- Header -->
<div mat-dialog-title>
	{{header}}
</div>

<!-- Body -->
<mat-dialog-content>

	<!-- Student Table -->
	<mat-table [dataSource]="tableData"
		class="studentTable"
		matSort
		matSortDisableClear
		matSortActive="name"
		matSortDirection="asc">

		<!-- Student # Column -->
		<ng-container matColumnDef="studentNumber">
			<mat-header-cell mat-sort-header="number"
				*matHeaderCellDef
				translate>
				Student #
				<filter *ngIf="V10"
					[data]="tableData"
					columnName="number"
					dataType="number"
					id="studentNumberFilter"
					class="mat-filter"></filter>
			</mat-header-cell>
			<mat-cell *matCellDef="let student">
				{{student.StudentNumber}}
			</mat-cell>
		</ng-container>

		<!-- Name Column -->
		<ng-container matColumnDef="name">
			<mat-header-cell mat-sort-header="name"
				*matHeaderCellDef
				translate>
				Name
				<filter [data]="tableData"
					columnName="name"
					dataType="string"
					id="nameFilter"
					class="mat-filter"></filter>
			</mat-header-cell>
			<mat-cell *matCellDef="let student">
				<!-- TODO: check permissions -->
				<a (click)="viewStudent(student)">
					{{student.formattedName(generalPreferences)}}
				</a>
			</mat-cell>
		</ng-container>

		<!-- Row Definitions -->
		<mat-header-row *matHeaderRowDef="['studentNumber', 'name']"></mat-header-row>
		<mat-row *matRowDef="let row; columns: ['studentNumber', 'name'];"
			matRipple></mat-row>
	</mat-table>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Right -->
	<div class="flex-footer-right">
		<tyl-button label="Close"
			image="Cancel.png"
			(clickEvent)="close()"></tyl-button>
	</div>
</mat-dialog-actions>